import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { PickerDirective } from '@shared/directives/picker.directive';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReportingToolTemplateSelectionComponent } from '@shared/components/reporting-tool-template-selection/reporting-tool-template-selection.component';
import { IQueryReportTemplate } from '@shared/interfaces/queries/IQueryReportTemplate';
import { IReportTemplate } from '@shared/interfaces';

@Component({
    selector: 'reporting-tool-template-picker',
    templateUrl: './reporting-tool-template-picker.component.html',
    styleUrls: ['./reporting-tool-template-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReportingToolTemplatePickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ReportingToolTemplatePickerComponent extends PickerDirective {
    @Input() query: IQueryReportTemplate;
    @Output() modify = new EventEmitter<IReportTemplate>();
    @Output() preview = new EventEmitter<IReportTemplate>();
    @Input() editable: boolean;
    @Input() deletable: boolean;

    get singleValue(): ISimpleTemplate {
        return this.value as ISimpleTemplate;
    }

    get multipleValue(): ISimpleTemplate[] {
        return this.value as ISimpleTemplate[];
    }

    clear() {
        this.writeValue(null);
        this.propagateChange(this.value);
    }

    openDialog() {
        this.dialog
            .open(ReportingToolTemplateSelectionComponent, {
                position: { top: '50px' },
                panelClass: 'custom-dialog',
                data: { query: this.query }
            })
            .beforeClosed()
            .subscribe((e: ISimpleTemplate) => {
                if (e) {
                    if (!this.multiple) {
                        this.value = e;
                        this.propagateChange(this.value);
                    } else {
                        if (!(this.value as ISimpleTemplate[]).some(i => i.id === e.id)) {
                            (this.value as ISimpleTemplate[]).push(e);
                            this.propagateChange(this.value);
                        }
                    }
                }
            });
    }
}

export interface ISimpleTemplate {
    title: string;
    versionNumber: string;
    id: string;
}
